import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { t } from '@billes/translator-client'

export default connect(
  {
    client: state`app.client.name`,
    banner: state`app.client.banner`,
    getStarted: signal`startPage.getStarted`
  },
  class Banner extends Component {
    onGetStarted(e) {
      e.preventDefault()
      e.stopPropagation()
      const { getStarted } = this.props
      getStarted()
    }

    render() {
      const { client, banner } = this.props
      return (
        <div
          className={css(styles.banner)}
          style={{
            backgroundImage: `url(${banner})`
          }}
        >
          <div className={css(styles.bannerBlock)}>
            <h1 className={css(styles.bannerHeadline)}>
              {t('bms.startpage.banner.headline', {
                client: `${client}`
              })}
            </h1>
            <p className={css(styles.bannerText)}>
              {t('bms.startpage.banner.subHeadline')}
            </p>
            <p className={css(styles.bannerText)}>
              <span
                dangerouslySetInnerHTML={{
                  __html: t('bms.startpage.banner.content')
                }}
              />
            </p>
            <div style={{ textAlign: 'right' }}>
              <div
                className={css(styles.bannerButton)}
                onClick={e => this.onGetStarted(e)}
              >
                {t('bms.startpage.banner.action')}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/StartPage/Banner/banner.js